// import React from 'react';
// import icons from '../../../icons.config'; // Import your icons from the config
// import GlobalButton from '../../GlobalButton';
// import { useNavigate } from 'react-router-dom';

// const AboutUs = () => {
 
//   const aboutUsData = [
//     {
//       icon: icons.customFit,
//       title: 'Custom Fit',
//       description: 'We offer a wide range of high-quality products that meet the needs of our customers.',
//     },
//     {
//       icon: icons.luxuryFabrics,
//       title: 'Luxury Fabrics',
//       description: 'Our customers are our priority, and we strive to provide excellent service and support.',
//     },
//     {
//       icon: icons.modernStyles,
//       title: 'Modern Styles',
//       description: 'Our team consists of experts who are dedicated to helping you find the right solutions.',
//     },
//   ];
//   const navigate=useNavigate();
//   const goToAbout=()=>{
//     navigate("/aboutus");
//    }
//   return (
//     <section className="py-10 lg:py-12 xl:py-10 px-4 md:px-40 bg-primary2 relative top-0 overflow-hidden z-10">
//       {/* given top-28 just to check component's design */}
  
     
//        {/* left Doodle Image in smaller screens*/}
//       <div className='lg:hidden'>
//       <div className="absolute left-0 top-0">
//             <img src={icons.amLine1} alt="Doodle Left" className="w-28 md:w-40 " />
//             </div> 
//       </div>
      
//        {/* Left Doodle Image in larger screens*/}
//        <div className="hidden lg:block absolute left-0 lg:top-0 xl:top-0">
//           <img src={icons.aLine1} alt="Doodle Left" className="lg:w-3/4 xl:w-4/5" />
//         </div>
//       <h2 className="text-center text-3xl font-outfit font-light mb-8 relative bottom-1 ">ESSENCE OF DIKOST</h2>
//       <div className="flex flex-col items-center">
//         <div className="grid grid-cols-1 md:grid-cols-3 md:gap-52">
//           {aboutUsData.map((item, index) => (
//             <div key={index} className="flex flex-col items-center relative">
//               {/* Circular Background */}
//               <div className="bg-primary1 shadow-lg rounded-full h-32 w-32 mb-4 relative flex items-center justify-center  ">
//                 {/* Icon placed inside the circle */}
//                 <img src={item.icon} alt={item.title} className="h-32 w-32  whitespace-nowrap" />
//               </div>
//               {/* Text Content */}
//               <h3 className="text-xl font-outfit font-normal mt-1 mb-10 text-hcolor md:text-center lg:text-start md:ml-2 lg:mt-0 text-nowrap">{item.title}</h3>
//             </div>
//           ))}
//         </div>
       
//       </div>
//       <p className='font-poppins font-normal text-md flex text-center text-primary1 mt-2 px-7 md:px-0 '>At Dikost, we redefine fashion with perfect fits and innovative style. Our customizable sizes are crafted to celebrate your individuality, making every outfit feel like it was made just for you. We use highest- quality, premium fabrics blending luxury with comfort, ensuring you never have to compromise on style.</p>
//        <div className='flex justify-center mt-8'>
//        <button className='border-2 py-2 px-3 flex text-hcolor font-outfit font-medium hover:bg-hcolor hover:text-primary2 transition-all duration-500 ease-in-out'><GlobalButton label="KNOW MORE" routeName="aboutUs" onClick={goToAbout}/></button>
//        </div>
       
//        {/* Right Doodle Image in smaller screens*/}
//        <div className='lg:hidden'>
            
//             <div className='absolute -right-2 bottom-0 '>
//             <img src={icons.amLine2} alt="Doodle Right" className="w-40 " />
//           </div>
//               </div>
      
//        {/* Right Doodle Image in larger screens*/}
//        <div className="hidden lg:block absolute lg:-right-[23%] lg:top-[66%]  xl:-right-40  xl:top-[50%]">
//           <img src={icons.aLine2} alt="Doodle Right" className="lg:w-2/4 xl:w-2/3" />
//         </div>
//     </section>
//   );
// };

// export default AboutUs;
import React, { useState, useEffect } from "react";
import icons from "../../../icons.config";
import GlobalButton from "../../GlobalButton";
import { useNavigate } from "react-router-dom";
import { IMAGE_BASE_URL } from "../../../api-urls";

const AboutUs = ({ aboutData }) => {
  const [aboutUsData, setAboutUsData] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    console.log("aboutData:", aboutData);
    if (aboutData && Array.isArray(aboutData)) {
      setAboutUsData(aboutData);
    }
  }, [aboutData]);
  
  

  const goToAbout = () => {
    navigate("/aboutus");
  };
  if(!aboutData){
    return null;
  }

  return (
    <section className="py-10 lg:py-12 xl:py-10 px-4 md:px-40 bg-primary2 relative top-0 overflow-hidden z-10">
      {/* Left Doodle Images */}
      <div className="lg:hidden absolute left-0 top-0">
        <img src={icons.amLine1} alt="Doodle Left" className="w-28 md:w-40" />
      </div>
      <div className="hidden lg:block absolute left-0 lg:top-0 xl:top-0">
        <img src={icons.aLine1} alt="Doodle Left" className="lg:w-3/4 xl:w-4/5" />
      </div>

      {/* Dynamic Title */}
      <h2 className={`text-center text-3xl font-outfit font-light mb-8 relative bottom-1 ${aboutData?.title_color || "text-hcolor"}`}>
        {aboutData?.title || "ESSENCE OF DIKOST"}
      </h2>

      <div className="flex flex-col items-center">
        <div className="grid grid-cols-1 md:grid-cols-3 md:gap-52">
        {aboutUsData?.map((item, index) => (
  <div key={index} className="flex flex-col items-center relative">
    {/* Circular Background */}
    <div className="bg-primary1 shadow-lg rounded-full h-32 w-32 mb-4 flex items-center justify-center">
      {/* Image from API */}
      <img
        src={IMAGE_BASE_URL+item?.image} // Correct image access
        alt={item.title} // Correct title access
        className="h-32 w-32 object-cover rounded-full"
      />
    </div>
    {/* Text Content */}
    <h3 className="text-xl font-outfit font-normal mt-1 mb-10 text-hcolor text-center">
      {item.title} 
    </h3>
  </div>
))}

        </div>
      </div>

      {/* Dynamic Description */}
      <p className={`font-poppins font-normal text-md text-center mt-2 px-7 md:px-0 ${aboutData?.description_color || "text-hcolor"}`}>
        {aboutData?.description || "At Dikost, we redefine fashion with perfect fits and innovative style. Our customizable sizes are crafted to celebrate your individuality, making every outfit feel like it was made just for you. We use high-quality, premium fabrics blending luxury with comfort, ensuring you never have to compromise on style."}
      </p>

      <div className="flex justify-center mt-8">
        {/* <button
          className="border-2 py-2 px-3 text-hcolor font-outfit font-medium hover:bg-hcolor hover:text-primary2 transition-all duration-500"
          onClick={goToAbout}
        > */}
          <GlobalButton label="KNOW MORE" routeName="aboutUs"  className="border-2 py-2 px-3 text-hcolor font-outfit font-medium hover:bg-hcolor hover:text-primary2 transition-all duration-500" />
        {/* </button> */}
      </div>

      {/* Right Doodle Images */}
      <div className="lg:hidden absolute -right-2 bottom-0">
        <img src={icons.amLine2} alt="Doodle Right" className="w-40" />
      </div>
      <div className="hidden lg:block absolute lg:-right-[23%] lg:top-[66%] xl:-right-40 xl:top-[50%]">
        <img src={icons.aLine2} alt="Doodle Right" className="lg:w-2/4 xl:w-2/3" />
      </div>
    </section>
  );
};

export default AboutUs;
